import http from './http';

export default {
  get() {
    return http().get(`/v2/fieldmaps`);
  }
}
